import type { BuilderType } from '@shared/utils/api/configs/rtkBaseQueryDemo';
import { GET_CAREGIVERS_HEALTH_RECORDS_TYPES } from '@shared/utils/api/configs/URL';
import { hasCcdpSuccess } from '@shared/utils/api/handlers/interpretCcdpCode/interpretCcdpCode';

import type {
  GetCaregiversHealthRecordTypesResponse,
  HealthRecordType,
} from '../types/getCaregiversHealthRecordTypes.types';

export const getCaregiversHealthRecordTypes = (builder: BuilderType) =>
  builder.query<HealthRecordType[], void>({
    query: () => ({
      isErrMsgConcatErrCode: false,
      method: 'POST',
      url: GET_CAREGIVERS_HEALTH_RECORDS_TYPES,
    }),
    transformResponse: (response: GetCaregiversHealthRecordTypesResponse) => {
      if (hasCcdpSuccess(response)) {
        return response.Result.map((item) => ({
          ...item,
          Granted: true,
        }));
      }

      throw {
        code: response.Code,
        message: response.Message,
      };
    },
  });
